/**
 * Embed-safe useDisplay: no VueUse so no effect teardown "bum" null.
 * Uses window.innerWidth + resize listener instead of useWindowSize().
 */
import { ref, computed, onMounted, onUnmounted } from 'vue';

function getWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : 1024;
}

const screen = ref({
  isMobile: null,
  isTablet: null,
  isDesktop: null,
});
const displayModes = ref({});
const isMobile = ref(false);
const isTablet = ref(false);
const isDesktop = ref(false);
const displayType = computed(() => ((isMobile.value && 'mobile') || (isTablet.value && 'tablet') || 'desktop'));
const setDisplayModes = (newDisplayModes) => {
  displayModes.value = newDisplayModes;
};
const isSlideoutMode = computed(() => displayModes.value[displayType.value] === 'slideout');
const isDropdownMode = computed(() => displayModes.value[displayType.value] === 'dropdown');

export default function useDisplay() {
  const updateDisplay = () => {
    const w = getWidth();
    screen.value.isMobile = w < 600;
    screen.value.isTablet = w < 1024 && w >= 600;
    screen.value.isDesktop = w >= 1024;
    isTablet.value = screen.value.isTablet;
    isMobile.value = screen.value.isMobile;
    isDesktop.value = screen.value.isDesktop;
  };

  onMounted(() => {
    updateDisplay();
    window.addEventListener('resize', updateDisplay);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', updateDisplay);
  });

  return {
    updateDisplay,
    screen,
    isMobile,
    isTablet,
    isDesktop,
    displayType,
    setDisplayModes,
    displayModes,
    isSlideoutMode,
    isDropdownMode,
  };
}
